export type Question = {
  labels?: { negative: string; positive: string };
  name: string;
  question: string;
  required: boolean;
  type: 'score' | 'text';
};

export const questions: Question[] = [
  {
    question: 'How satisfied are you with the operational services provided by Zencargo?',
    type: 'score',
    name: 'operationalServices',
    required: true,
    labels: {
      positive: 'Very satisfied',
      negative: 'Not satisfied'
    }
  },
  {
    question: 'How confident are you in the visibility provided by Zencargo?',
    type: 'score',
    name: 'visibility',
    required: true,
    labels: {
      positive: 'Very confident',
      negative: 'Not confident'
    }
  },
  {
    question: 'How likely are you to recommend Zencargo as a freight partner to your peers?',
    type: 'score',
    name: 'recommendation',
    required: true,
    labels: {
      positive: 'Very likely',
      negative: 'Not likely'
    }
  },
  {
    question: 'How effectively does Zencargo keep you updated on market conditions?',
    type: 'score',
    name: 'marketConditions',
    required: true,
    labels: {
      positive: 'Very effective',
      negative: 'Not effective'
    }
  },
  {
    question: 'Is there anything that Zencargo can support you on your current business?',
    type: 'text',
    name: 'businessSupport',
    required: false
  },
  {
    question: "We'd love to hear your thoughts! Feel free to share any comments you have.",
    type: 'text',
    name: 'additionalComments',
    required: false
  }
];
